import { useEffect, useRef, useState } from 'react'
import OneSignal from 'react-onesignal'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { notificationTone } from '../../assets/index'
import { getToken } from '../../redux_store/asyncConfig'
import { updateNotificationToken } from '../../redux_store/auth/auth_thunk'
import { useSocket } from '../../redux_store/support/socket_hook'
import NavBar from './Navbar'
import SideBar from './SideBar'
import PushNotification from './modals/PushNotification'

const DashBoard = (props) => {
  const location = useLocation();
  const navigator = useNavigate();
  const [pushNotification, setPushNotification] = useState({
    visible: false, title: '', message: ''
  });
  const dispatch = useDispatch();
  const notButtonRef = useRef(null);
  const auth = useSelector((state) => state.auth);
  const sound = new Audio(notificationTone);
  const playNotificationSound = () => {
    sound.play().catch(() => {
      // Browsers block autoplay until the user interacts with the page.
    });
  };

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.add('light');
    runOneSignal()
    onesignalEvents();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    onesignalEvents();
  });

  useEffect(() => {
    if (pushNotification.visible) {
      setTimeout(() => {
        setPushNotification({ visible: false, title: '', message: '' });
      }, 6000);
    }
    // eslint-disable-next-line
  }, [pushNotification.visible]);

  const onesignalEvents = () => {
    OneSignal.on('subscriptionChange', function (isSubscribed) {
      playNotificationSound();
      setPushNotification({
        visible: true,
        title: 'Subscription State',
        message: `The user's subscription state is now ${isSubscribed}`
      });
    });
    OneSignal.on('permissionPromptDisplay', function (data) {
      playNotificationSound();
      setPushNotification({
        visible: true,
        title: 'Notification Permission',
        message: `When permission is accepted, you would be notified for messages and major actions`
      });
    });
    OneSignal.on('notificationPermissionChange', function (data) {
      playNotificationSound();
      let title = '', description = '';
      if (data.to === 'granted') {
        title = 'Notification Permission Granted';
        description = 'You have been granted permission to receive notifications';
      } else {
        title = 'Notification Permission Denied';
        description = 'You have been denied permission to receive notifications';
      }
      setPushNotification({
        visible: true,
        title,
        message: description
      });
    });
    OneSignal.on('popoverShown', function (data) {
      playNotificationSound();
    });
    OneSignal.on('notificationDisplay', function (data) {
      playNotificationSound();
      setPushNotification({
        visible: true,
        title: data.heading,
        message: data.content
      });
    });
    OneSignal.on('notificationDissmis', function (data) {
      playNotificationSound();
    });
  }


  const runOneSignal = async () => {
    await OneSignal.init({
      appId: process.env.REACT_APP_ONESIGNAL_APPID,
      persistNotification: true,
    });
    OneSignal.showSlidedownPrompt().then(() => {
      console.log('slide shown here......');
    });
    await OneSignal.getUserId(function (userId) {
      console.log("OneSignal User ID:", userId);
      if (userId && userId !== '')
        dispatch(updateNotificationToken(userId))
    });
    const permission = await OneSignal.getNotificationPermission();
    if (permission) {
      playNotificationSound();
      setPushNotification({
        visible: true,
        title: 'Notification Status',
        message: `Admin notifications permission ${permission}`
      });
    }
    if (permission !== 'granted') {
      await OneSignal.registerForPushNotifications();
      await OneSignal.showSlidedownPrompt();
    }
    const isPushEnabled = await OneSignal.isPushNotificationsEnabled();
    if (!isPushEnabled) {
      await OneSignal.registerForPushNotifications();
      await OneSignal.showSlidedownPrompt();
      playNotificationSound();
      setPushNotification({
        visible: true,
        title: 'Notification Permission',
        message: `Kindly enable push notifications for this browser`
      });
    } else {
      setPushNotification({
        visible: true,
        title: 'Notification Permission',
        message: `Push notifications enabled for this browser`
      });
    }
  }

  useEffect(() => {
    if (getToken()) {
      if (location.pathname === '/') {
        navigator('/login')
      } else if (location.pathname === '/login') {
        navigator('/analytics');
      } else {
        navigator(location.pathname);
      }
    } else {
      navigator('/login');
    }
    // eslint-disable-next-line
  }, [location.pathname, auth.authState]);

  const handler = useSocket();
  useEffect(() => {
    handler.initializeSockets();
    // eslint-disable-next-line
  }, []);

  return (
    <div className='h-screen w-full grid grid-cols-12 bg-surface-50'>
      {/* Sidebar */}
      <SideBar page={props.path} />

      {/* Push Notification */}
      {pushNotification.visible && (
        <PushNotification
          title={pushNotification.title}
          message={pushNotification.message}
        />
      )}

      {/* Main Content Area */}
      <main className='h-screen col-span-10 flex flex-col overflow-hidden'>
        <NavBar />

        {/* Content */}
        <div className='flex-1 overflow-y-auto scrollbar-thin'>
          <div className='p-6 min-h-full'>
            <button hidden ref={notButtonRef}></button>
            <div className='animate-fade-in'>
              <Outlet />
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default DashBoard
